import type { Locale } from "@/lib/i18n";
import { pl, type CRealizationsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cRealizationsTranslations: Record<Locale, CRealizationsTranslations> = {
  pl,
  en,
  de,
};

export type { CRealizationsTranslations };
